package com.hyperether.goodjob.navigation

import kotlinx.browser.window

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
actual object PersistStore {
    actual fun getInt(key: String, default: Int): Int =
        window.sessionStorage.getItem(key)?.toIntOrNull() ?: default

    actual fun putInt(key: String, value: Int) {
        window.sessionStorage.setItem(key, value.toString())
    }
}